<template>
  <div>
    <Header :headerContent="headerContent" />
    <cross-page-info :crossPageContent="crossPageContent" />
    <frequently-asked-questions
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :fromBackend="true"
    />
    <Blog />
    <customer-comments />
  </div>
</template>

<script>
import Header from '@/component/cross-pages/Header'
import crossPageInfo from '@/component/cross-pages/CrossPageInfo'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import Blog from '@/component/alo-kasko-blog-carousel/AppAloKaskoBlog'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import CreditInsuranceData from '@/data/company-page-data/quick-sigorta/cross-pages/CreditInsurance'
export default {
  metaInfo: {
    title: 'Quick Sigorta Devlet Destekli (Ticari) Alacak Sigortası',
    meta: [
      {
        name: 'description',
        content:
          'Quick Sigorta KOBİ alacak sigortası primlerini öğrenmek ve yaptımak için sitemizi ziyaret edebilir, vadeli ticari alacaklarınızı güvence altına alabilirsiniz.'
      }
    ]
  },
  name: 'QuickSigortaCreditInsurance',
  components: {
    Header,
    crossPageInfo,
    frequentlyAskedQuestions,
    Blog,
    customerComments
  },
  data () {
    return {
      headerContent: CreditInsuranceData.headerContent,
      crossPageContent: CreditInsuranceData.crossPageContent,
      faqTitle: CreditInsuranceData.faqTitle,
      faqTitleDesc: CreditInsuranceData.faqTitleDesc,
      getPrice: CreditInsuranceData.getPrice
    }
  }
}
</script>
